import clsx from 'clsx';
import { forwardRef } from 'react';
import tw, { styled } from 'twin.macro';

type Props = {
  variant?: 'primary' | 'secondary' | 'cancel';
  fullWidth?: boolean;
  rounded?: boolean;
};

interface ButtonProps
  extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    Props {
  loading?: boolean;
}

const WrapperButton = styled.button<{
  $variant: Props['variant'];
  $rounded: Props['rounded'];
}>(({ $variant, $rounded }) => [
  tw`
 p-[12px] text-[14px] leading-[20px] relative font-medium capitalize flex justify-center items-center transition-all duration-300 gap-[10px] disabled:opacity-50`,

  $variant === 'secondary'
    ? tw`bg-white text-primary-900 border border-primary-500`
    : $variant === 'cancel'
      ? tw`bg-transparent text-[#949EAC] border-0`
      : tw`bg-primary-500 text-white`,

  $rounded ? tw`rounded-[100px]` : tw`rounded-[8px]`,
]);

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', children, className, loading, disabled, rounded, ...props }, ref) => {
    return (
      <WrapperButton
        className={clsx(className, {
          'opacity-50 pointer-events-none': loading,
          'rounded-[100px]': rounded,
        })}
        disabled={disabled}
        {...props}
        ref={ref as React.ForwardedRef<HTMLButtonElement>}
        $variant={variant}
        $rounded={rounded}
      >
        {/* <div className={`flex justify-center items-center transition-all duration-300`}> */}
        {loading ? 'Loading...' : children}
        {/* </div> */}
      </WrapperButton>
    );
  }
);

Button.displayName = 'Button';

export default Button;
